import { NotifStatus } from '@commons/bo-ui/notifications/notif-status.enum';

export interface INotif {
  message: string;
  style?: NotifStatus;
  duration?: number;
  callbackConfig?: ICallbackConfig;
  callback?: (args?: unknown) => unknown;
  canCancelled?: boolean;
  cancelCallback?: (args?: unknown) => unknown;
}

export interface ICallbackConfig {
  text: string;
  callback: (args?: unknown) => unknown;
}

export class Notif {
  id: string;
  message: string;
  style?: NotifStatus;
  duration?: number;
  callbackConfig?: ICallbackConfig;
  callback?: (args?: unknown) => unknown;
  timeout?: any;
  canCancelled?: boolean;
  cancelCallback?: (args?: unknown) => unknown;

  constructor(data: INotif) {
    this.id = Math.random().toString(36).substr(2, 9);
    this.message = data.message;
    this.style = data.style || NotifStatus.Info;
    this.duration = data.duration;
    this.callbackConfig = data.callbackConfig;
    this.callback = data.callback;
    this.canCancelled = data.canCancelled;
    this.cancelCallback = data.cancelCallback;
  }
}
